import { render, staticRenderFns } from "./settledTab.vue?vue&type=template&id=68b59938&scoped=true&"
import script from "./settledTab.vue?vue&type=script&lang=js&"
export * from "./settledTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b59938",
  null
  
)

export default component.exports